import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';
import { ModalDirective } from 'ngx-bootstrap';

import { SiterecordComment } from 'app/models';

@Component({
  selector: 'app-dialog-capture-comment',
  templateUrl: './dialog-capture-comment.component.html'
})
export class DialogCaptureCommentComponent implements OnInit {
  @ViewChild('captureCommentDialog') captureCommentDialog: ModalDirective;
  @ViewChild('commentForm') public commentForm: NgForm = null;

  @Output() onConfirm = new EventEmitter<SiterecordComment>();
  @Output() onCancel = new EventEmitter();

  public isInternal = false;

  constructor(protected readonly translateService: TranslateService) {}

  ngOnInit() {}

  public show(): void {
    this.captureCommentDialog.show();
  }

  public confirm(): void {
    this.captureCommentDialog.hide();

    const siterecordComment = {
      comment: this.commentForm.value.comment,
      internal: this.commentForm.value.isInternal
    } as SiterecordComment;

    this.onConfirm.emit(siterecordComment);
  }

  public cancel(): void {
    this.captureCommentDialog.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-capture-comment/dialog-capture-comment.component.ts